<template>
    <div class="page bgF5F5F5 underlineCourse">

        <div style="height: 46px; line-height: 46px;">
            <header class="pageHeader detailPageHeader paddingH16 paddingV8 white_bg lightGreyBottomBorder">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px"></div>
                    </div>
                </div>
            </header>
        </div>

        <form class="body" @submit="submit" action="javascript:;">
            <div class="">

                <div class="dataRow marginB8 white_bg">
                    <div class="flexLayout">
                        <div style="width: 140px; margin-right: 8px;">
                            <div class="imageArea roundBorder8 hiddenOverflow w100p"
                                 style="height: 83px;">
                                <img class="fullSpace cover" :src="dataItem.coverImg"
                                     v-if="dataItem && dataItem.coverImg"/>
                            </div>
                        </div>

                        <div class="flexItem">
                            <div class="lineHeight21r14f bold font14r grey20 hiddenOverflow" style="
                                max-height: 3em;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;">
                                {{dataItem ? dataItem.title : ''}}
                            </div>
                            <div class="font12r grey bold marginT12">主办方：{{dataItem ? dataItem.teacherName : ''}}</div>
                        </div>
                    </div>
                </div>

                <div class="marginT8 paddingH16 white_bg">
                    <div class="font12r color333 paddingT16 paddingB8" style="border-bottom: solid 1px #F0F0F0;">
                        <i class="icon locationIcon marginR4"></i>
                        <strong class="bold" style="margin-right: 24px;">上课地址</strong>
                        {{dataItem ? dataItem.city : ''}} | {{dataItem ? dataItem.address : ''}}
                    </div>
                    <div class="font12r color333 paddingT8 paddingB16">
                        <i class="icon clockIcon marginR4"></i>
                        <strong class="bold" style="margin-right: 24px;">上课时间</strong>
                        {{dataItem ? formatDateTime(dataItem.startTime) : '未知'}}&nbsp;&nbsp;至&nbsp;&nbsp;
                        {{dataItem ? formatDateTimeWithoutYear(dataItem.endTime) : '未知'}}
                    </div>
                </div>

                <div class="marginT8 white_bg">
                    <div class="padding16">
                        <div class="color333 bold ">报名信息</div>
                        <div class="marginT8 red font10r">*填写报名信息，便于线下上课签到信息确认，请认真填写！</div>

                        <div class="formRow flexLayout">
                            <div class="columnName font14r color333" style="width: 81px;">姓名</div>
                            <div class="columnValue flexItem">
                                <!-- 设计图原先写的是“园区名”，所以是 parkName，接口不改 -->
                                <input type="text" class="inputbox block" required placeholder="请输入名称"
                                       v-model="formData.parkName"/>
                            </div>
                        </div>

                        <div class="formRow flexLayout">
                            <div class="columnName font14r color333" style="width: 81px;">手机号码</div>
                            <div class="columnValue flexItem">
                                <input type="number" class="inputbox block" required placeholder="请输入手机号码"
                                       v-model="formData.phone"/>
                            </div>
                        </div>

                        <div class="formRow flexLayout" data-notice="产品经理说怕用户写错写少手机号，所以要验证，每一次报名都要。">
                            <div class="columnName font14r color333" style="width: 81px;">验证码</div>
                            <div class="columnValue flexItem">
                                <button type="button" class="fr button getVerifyCodeButton" @click="getVerifyCode()"
                                        :disabled="formData.phone.length < 1 || verifyCodeSeconds > 0">
                                    <template v-if="verifyCodeSeconds==0">验证码</template>
                                    <template v-else>已发送</template>
                                </button>
                                <input type="text" class="inputbox block" pattern="[0-9]{6}"
                                       title="6位数字" placeholder="请输入验证码" required
                                       style="width: 120px;" v-model="formData.verificationCode" />
                            </div>
                        </div>

                        <div class="formRow flexLayout">
                            <div class="columnName font14r color333" style="width: 81px;">城市</div>
                            <div class="columnValue flexItem">
                                <select v-model="selectedProvince" class="areaSelector" @change="selectProvinceChange">
                                    <option value="province">省/直辖市</option>
                                    <option v-for="(item, i) in citiesList" :value="item" :key="i">
                                        {{ item.name }}
                                    </option>
                                </select>
                                <span style="margin: 0 6px;">—</span>
                                <select v-model="selectedCity" class="areaSelector" @change="selectCityChange">
                                    <option value="city">城市</option>
                                    <option v-for="(item, i) in selectedProvince ? selectedProvince.childList : []" :value="item" :key="i"
                                            :disabled="selectedProvince ? false : true">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="formRow flexLayout">
                            <div class="columnName font14r color333" style="width: 105px;">企业/园所名称</div>
                            <div class="columnValue flexItem">
                                <input type="text" class="inputbox block"
                                       placeholder="请输入您的企业名称或者园所名称"
                                       v-model="formData.companyName"/>
                            </div>
                        </div>

                        <div class="formRow flexLayout">
                            <div class="columnName font14r color333" style="width: 81px;">报名人数</div>
                            <div class="columnValue flexItem">
                                <input type="text" class="inputbox block" pattern="[0-9]*" title="正整数"
                                       placeholder="选择报名人数" required
                                       v-model="formData.applyCount"/>
                            </div>
                        </div>

                    </div>
                </div><!-- end white_bg panel -->

<!--                <div class="marginT8 white_bg" style="padding-bottom: 28px;">-->
<!--                    <div class="padding16">-->
<!--                        <div class="color333 bold ">购买须知</div>-->
<!--                        <div class="marginT8 darkgrey font10r">-->
<!--                            <p>1、该定金报名成功后概不退还；</p>-->
<!--                            <p>2、为了保证线下课程的正常授课及保证报名人的消费权益，课程报名需要收取报名定金，是收取原价-->
<!--                                {{dataItem ? dataItem.downPaymentProportion * 100 : '0'}}%；-->
<!--                            </p>-->
<!--                            <p>3、线下签到上课时交付剩余的报名费用，请知晓！</p>-->

<!--                        </div>-->
<!--                    </div>-->
<!--                </div>&lt;!&ndash; end white_bg panel &ndash;&gt;-->

            </div>

            <div style="height: 86px;">
                <div class="fixedBottom white_bg" style="height: 86px; box-shadow: 0px -4px 8px rgba(101, 101, 101, 0.08);">
                    <div style="padding: 5px 7px 5px 14px; line-height: 42px;">
                        <button class="confirmButton fr" type="submit">确认报名</button>
                        <span class="darkgrey font12r">应付:</span>
                        <span class="red font12r">¥</span>
                        <span class="red">{{dataItem ? dataItem.finalPrice * formData.applyCount : ''}}</span>
                    </div>
                </div>
            </div>

        </form><!-- end .body -->

        <payComp ref="payComp" :onPaySuccess="onPaySuccess"/>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import payComp from './payComp';

// style
import './style.scss';

// config
import appConfig from '@/appConfig';
import bizTypeEnum from '@/data/bizTypeEnum';

// api
import userApi from "@api/user";

// util
import appHelper        from '@/util/appHelper';
import consoleApi       from '@/components/platformApi/consoleApi';
import requestManager   from "@comp/platformApi/requestManager";
import timerManager     from "@comp/platformApi/timerManager";
import consoleHelper    from "@util/consoleHelper";
import routeHelper      from "@util/routeHelper";
import objectHelper     from "@util/objectHelper";
import moment from "moment";
import citiesList from "@data/citiesList_v2";

const config = {
    name : 'underlineCourseSignUpPage',
    title : '报名确认',
    description : '',
    apiConfig : {
        get : {
            url: 'portal/underline/v2/course/get',
            dataColumnMapping : {
                // userName : 'name'
            }
        },
        submit : {
            url : 'portal/underline/v2/process/apply',
            method : 'post'
        }
    },
    // unit: second
    verifyCodeSendDelay : 60
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : { payComp },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,

            enableDataItem: true,
            autoLoadDataItem: true,

            citiesList: citiesList,
            selectedProvince: 'province',
            selectedCity: 'city',

            formData : {
                courseId : '',
                parkName : '',
                phone : '',
                verificationCode : '',
                applyCount : '1',
                province : '',
                city : '',
            },
            verifyCodeSeconds : 0,
            countDownTimer : null,
        }
    },
    methods : {
        formatDateTime : function (timestamp) {
            if (!timestamp)
            {
                return '';
            }
            return moment(timestamp).format('YYYY-MM-DD HH:mm');
        },
        formatDateTimeWithoutYear : function (timestamp) {
            if (!timestamp)
            {
                return '';
            }
            return moment(timestamp).format('MM-DD HH:mm');
        },
        formatTimeRange(startTime, endTime) {
            return moment(startTime).format('HH:mm') + '-' + moment(endTime).format('HH:mm');
        },
        getVerifyCode() {

            if (!this.formData.phone)
            {
                return;
            }

            // check timer
            if (this.countDownTimer)
            {
                appHelper.showHint('验证码' + config.verifyCodeSendDelay + '秒内有效');
                return;
            }

            let sendVerifyCodeApi = userApi.sendVerifyCodeApi;
            sendVerifyCodeApi.data = {
                phone : this.formData.phone
            };

            requestManager.request(sendVerifyCodeApi, (error, result) => {
                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }

                let errorCode = result.errorCode || 0;
                if (errorCode)
                {
                    appHelper.showHint(result.msg);
                    return;
                }

                appHelper.showHint('发送成功，请查收。');

                this.verifyCodeSeconds = config.verifyCodeSendDelay;
                this.countDownTimer = timerManager.setInterval(() => {
                    this.verifyCodeSeconds--;

                    if (this.verifyCodeSeconds == 0)
                    {
                        timerManager.clearInterval(this.countDownTimer);
                        this.countDownTimer = null;
                    }
                }, 1 * 1000);
            });

        },
        submit() {

            if (!this.formData.verificationCode || !this.formData.phone || !this.formData.applyCount ||
                !this.formData.parkName)
            {
                appHelper.showHint('请填写完整信息');
                return false;
            }

            let options = objectHelper.clone(this.apiConfig.submit);
            options.data = this.formData;
            requestManager.request(options, (error, result) => {
                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }

                if (result.errorCode)
                {
                    appHelper.showHint(result.msg);
                    return;
                }

                // 还要调用一下支付接口
                this.$refs.payComp.setProduct({
                    id      : result.data.id,
                    title   : this.dataItem ? this.dataItem.title : '',
                    image   : this.dataItem ? this.dataItem.coverImg : '',
                    price   : this.dataItem ? this.dataItem.price : ''
                });
                this.$refs.payComp.agreeServiceProtocol = true;
                this.$refs.payComp.pay();

            });

            return false;
        },
        onPaySuccess: function (data) {

            let orderId = data.orderId;

            appHelper.showHint('报名成功');

            timerManager.setTimeout(() => {

                appHelper.goToPage('underlineCourseMyCourse');

            }, 2 * 1000);
        },

        selectProvinceChange (e) {
            this.selectedCity = 'city';
            this.selectedArea = 'area';
            this.dataItem.province = this.formData.province = this.selectedProvince.name;
        },
        selectCityChange (e) {
            this.selectedArea = 'area';
            this.dataItem.city = this.formData.city = this.selectedCity.name;
        },
    },
    mounted() {
        this.formData.courseId = routeHelper.getParam(this, 'id', '');
    }
}
</script>

<style lang="scss" scoped>
.formRow {
    line-height: 30px;
    .columnName {
        color: #5B616C;
        padding: 18px 0 6px;
    }
    .columnValue {
        padding: 18px 0 6px;
        border-bottom: 1px solid #F0F0F0;
        .inputbox {
            display: block;
            width: 100%;
            font-size: 87.5%;
            height: 30px;
            line-height: 30px;
            border: none;
            background: transparent;
            color: #333;
            outline: none;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: #B8C2D6;
        }
    }
    .getVerifyCodeButton {
        width: 53px;
        height: 21px;
        line-height: 21px;
        background: #FFB931;
        border: none;
        border-radius: 12px;

        font-size: 11px;
        color: white;
        &:disabled {
            opacity: .5;
        }
    }
    .areaSelector {
        display: inline-block;
        width: 100px;
        height: 24px;
        background: #f2f2f2;
        border: 1px solid #f0f0f0;

        border-radius: 2px;
        //appearance: none; /* 去掉默认图标 */
        // padding: 0 10px;
        text-align: center;
        //text-align-last: center;

        option {
            text-align: center;
        }
    }
}
.confirmButton {
    width: 190px;
    height: 42px;
    line-height: 42px;
    background: #FFBC3B;
    border: none;
    border-radius: 24px;
    font-size: 16px;
    color: white;
}
</style>
